module.exports = __webpack_public_path__ + "img/com_denpasar.07210027.png";